<template>
  <div class="flex w-50-l w-100 h-100 flex-column textColor" style="display: none;">
    <h3 class="textColor">{{$t("payment.mpConnect.title")}}</h3>
    <p class="dark-red f7" v-show="error">{{error}}</p>
    <div v-if="user.mpConnected">
      <p class="f6">{{$t("payment.mpConnect.connectedAs")}}:</p>
      <div class="flex items-center justify-start textColor">
        <div v-show="info.profile_picture" class="picture flex item-center justify-center">
          <img class="w-100 h-100 iconColor" :src="info.profile_picture">
        </div>
        <div class="mw-100">
          <h1 class="user-info f6 f5-ns fw6 lh-title mv0 mw-100 ph2 textColor">{{info.nickname}} <small :title="$t('payment.mpConnect.nickname_title_help')"><font-awesome-icon icon="question-circle" /></small></h1>
        </div>
      </div>
      <p class="f6 textColor">{{$t("payment.mpConnect.disconnectInfo")}}
        <a href="https://appstore.mercadolibre.com.ar/apps/permissions" target="_blank">Mercado Pago</a>
      </p>
    </div>
    <div class="flex flex-column items-start-l items-center" v-show="!user.mpConnected">
      <p class="w-100 tl textColor">{{$t("payment.mpConnect.info")}}</p>
      <button @click="connect" class="w-50-ns w-100 block mv2 pointer btn dim b f5 fw4">{{$t("payment.connect")}}</button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'payment-info',
    data () {
      return {
        info: null,
        error: ''
      }
    },
    computed: {
      ...mapGetters('user', [
        'user'
      ])
    },
    methods: {
      ...mapActions('artist', [
        'getPaymentInfo',
        'mpConnect'
      ]),
      connect () {
        this.mpConnect().then(res => {
          window.location.href = res.next_url
        }).catch(e => {
          this.error = e.message
        })
      }
    },
    created () {
      if (this.user.mpConnected) {
        this.getPaymentInfo().then(res => {
          this.info = res
        }).catch(e => {
          this.error = e.message
        })
      }
    }
  }
</script>

<style scoped>
  .picture {
    height: 45px;
    width: 45px;
  }
  .user-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/PaymentInfo.vue